import React, {Children} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import {black500, greyishBlue500} from "../../../../assets/jss/main";

Page.propTypes = {

};

function Page({children}) {
    const HeaderLeftPart = findSlotOfType(children, HeaderLeft);
    const HeaderRightPart = findSlotOfType(children, HeaderRight);
    const ContentPart = findSlotOfType(children, Content);

    return (
        <div style={{
            padding: '24px',
            borderRadius: '8px',
            background: '#FFF',
        }}>
            <Grid container justifyContent={'space-between'} marginBottom={6}>
                <Grid item xs={12} sm={6}>
                    {HeaderLeftPart}
                </Grid>
                <Grid item xs={12} sm={6} textAlign={'right'}>
                    {HeaderRightPart}
                </Grid>
            </Grid>
            <div>
                {ContentPart}
            </div>

        </div>
    );
}

function HeaderLeft({children}) {
    return children;
}

function HeaderRight({children}) {
    return children;
}

function Content({children}) {
    return children
}

function Title({children}) {
    return (
        <b style={{ fontSize: '24px', color: black500 }}>
            {children}
        </b>
    )
}
function Subtitle({children}) {
    return (
        <div style={{ fontSize: '16px', color: greyishBlue500 }}>
            {children}
        </div>
    )
}

function findSlotOfType(children, slotType) {
    return Children.toArray(children).find((child) => child.type === slotType);
}

export default Object.assign(Page, { HeaderLeft, HeaderRight, Title, Subtitle, Content });

